<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="file_034"></a><a id="page_19"><img alt="Image" src="images/f0019-01.jpg"/></a></p><a id="page_19">
<p class="caption">This is embarrassing. Many veteran naval and marine pilots weren’t used to having to deal with landing gear. On a fighter like the Boeing F4B, the gear was always down. Grumman’s new planes were different—a flyer had to <em>remember</em> to lower the gear or there was going to be trouble. This Marine Corps F3F-2 came to a grinding halt at Turner Field, Virginia, in late 1937. <em>Grumman History Center</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_034.vue?179332a4